import { render, staticRenderFns } from "./TreeCategorySelector.vue?vue&type=template&id=13c8ec51"
import script from "./TreeCategorySelector.vue?vue&type=script&lang=js"
export * from "./TreeCategorySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports